module.exports = __webpack_public_path__ + "img/1453887562.76b64145.jpg";